import React, { useState } from "react";
import { Typography } from "@mui/material";
import Countdown from "react-countdown";

import { phoneExpireTime } from "src/config";

const Timer = () => {
  const Completionist = () => (
    <Typography color="primary">請重新索取驗證碼</Typography>
  );
  const [date, setDate] = useState(Date.now() + phoneExpireTime);
  // Renderer callback with condition
  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a complete state
      return <Completionist />;
    } else {
      // Render a countdown
      return (
        <Typography color="primary">
          請在{minutes}:{seconds < 10 ? `0${seconds}` : seconds}內輸入驗證碼
        </Typography>
      );
    }
  };
  return <Countdown date={date} renderer={renderer} />;
};

export default Timer;
